(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/active-game.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/active-game.js');
'use strict';

const Brand = svs.ui.ReactBrand;
const ListItemLink = svs.ui.ReactListGroup.ListItemLink;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const _svs$arena$pages$team = svs.arena.pages.teams.helpers,
  getMultiWeekText = _svs$arena$pages$team.getMultiWeekText,
  wagerDetailUrl = _svs$arena$pages$team.wagerDetailUrl;
const ActiveGame = _ref => {
  let wager = _ref.wager;
  const multiWeek = getMultiWeekText(wager);
  const wagerDetailLink = svs.utils.url.makeInternal(wagerDetailUrl(wager));
  return React.createElement(ListItemLink, {
    className: "ms-hover-tur-100 transparent-border-override"
  }, React.createElement("a", {
    href: wagerDetailLink,
    onClick: () => {}
  }, React.createElement("div", {
    className: "u-flex"
  }, React.createElement(ErrorBoundary, null, React.createElement(Brand, {
    brand: wager.productName,
    size: 200,
    square: true
  })), React.createElement("div", {
    className: "padding-xs-left-1"
  }, React.createElement("div", {
    className: "f-bold"
  }, wager.productName, ' ', multiWeek), wager.hasJoker && React.createElement("span", {
    className: "f-bold"
  }, "+ Joker"), React.createElement("div", null, wager.cancelCloseTime ? "N\xE4sta dragning: ".concat(svs.utils.date.ShortDateAndTime(wager.cancelCloseTime, false, true)) : 'Dragning')))));
};
svs.arena.pages.teams.components.ActiveGame = ActiveGame;

 })(window);